(function(){
  'use strict';

  /* THREE.JS BACKGROUND */
  let scene,camera,renderer,particles,particlesGeo,orbitRing;
  let mouseX=0,mouseY=0,targetMouseX=0,targetMouseY=0;
  let bgColors={current:{r:.04,g:.06,b:.07},target:{r:.04,g:.06,b:.07}};
  let particleColorMode='default';

  // Reduce particle count on mobile for better performance
  const isMobile = window.matchMedia('(max-width: 768px)').matches;
  const PARTICLE_COUNT = isMobile ? 600 : 1200;
  const RING_COUNT = isMobile ? 120 : 240;

  const palette={
    default:[{r:.78,g:.95,b:.24},{r:.12,g:.66,b:.60},{r:.95,g:.92,b:.86}],
    spirulina:[{r:.78,g:.95,b:.24},{r:.12,g:.23,b:.16},{r:.16,g:.29,b:.21}],
    restopil:[{r:.78,g:.95,b:.24},{r:.36,g:.31,b:.75},{r:.18,g:.16,b:.33}],
    gutflo:[{r:.91,g:.48,b:.16},{r:.83,g:.39,b:.09},{r:.95,g:.92,b:.86}],
    trio:[{r:.78,g:.95,b:.24},{r:.36,g:.31,b:.75},{r:.91,g:.48,b:.16}]
  };

  function createParticleSprite(){
    const c=document.createElement('canvas');c.width=64;c.height=64;
    const ctx=c.getContext('2d');
    const g=ctx.createRadialGradient(32,32,0,32,32,32);
    g.addColorStop(0,'rgba(255,255,255,1)');g.addColorStop(.25,'rgba(255,255,255,0.6)');
    g.addColorStop(.5,'rgba(255,255,255,0.2)');g.addColorStop(1,'rgba(255,255,255,0)');
    ctx.fillStyle=g;ctx.fillRect(0,0,64,64);
    const tex=new THREE.CanvasTexture(c);tex.minFilter=THREE.LinearFilter;
    return tex;
  }

  function initThree(){
    const canvas=document.getElementById('smr-bg-canvas');
    if(!canvas||typeof THREE==='undefined')return;
    scene=new THREE.Scene();scene.background=new THREE.Color(0x0a0e10);
    scene.fog=new THREE.FogExp2(0x0a0e10,.0008);
    camera=new THREE.PerspectiveCamera(75,innerWidth/innerHeight,1,3000);camera.position.z=800;
    renderer=new THREE.WebGLRenderer({canvas,antialias:!isMobile,alpha:false,powerPreference:'high-performance'});
    renderer.setPixelRatio(Math.min(devicePixelRatio,isMobile?1.5:2));
    renderer.setSize(innerWidth,innerHeight);

    particlesGeo=new THREE.BufferGeometry();
    const positions=new Float32Array(PARTICLE_COUNT*3),colors=new Float32Array(PARTICLE_COUNT*3),sizes=new Float32Array(PARTICLE_COUNT);
    for(let i=0;i<PARTICLE_COUNT;i++){
      const i3=i*3;const r=600+Math.random()*800;
      const theta=Math.random()*Math.PI*2;const phi=Math.acos((Math.random()*2)-1);
      positions[i3]=r*Math.sin(phi)*Math.cos(theta);
      positions[i3+1]=r*Math.sin(phi)*Math.sin(theta);
      positions[i3+2]=r*Math.cos(phi);
      const pal=palette.default;const c=pal[Math.floor(Math.random()*pal.length)];
      colors[i3]=c.r;colors[i3+1]=c.g;colors[i3+2]=c.b;
      sizes[i]=Math.random()*4+2;
    }
    particlesGeo.setAttribute('position',new THREE.BufferAttribute(positions,3));
    particlesGeo.setAttribute('color',new THREE.BufferAttribute(colors,3));
    particlesGeo.setAttribute('size',new THREE.BufferAttribute(sizes,1));
    const particlesMat=new THREE.PointsMaterial({size:6,map:createParticleSprite(),vertexColors:true,transparent:true,opacity:.85,blending:THREE.AdditiveBlending,depthWrite:false,sizeAttenuation:true});
    particles=new THREE.Points(particlesGeo,particlesMat);scene.add(particles);

    const geo=new THREE.BufferGeometry();
    const pos=new Float32Array(RING_COUNT*3),col=new Float32Array(RING_COUNT*3);
    for(let i=0;i<RING_COUNT;i++){
      const t=(i/RING_COUNT)*Math.PI*2;const radius=380+Math.sin(i*.3)*30;
      pos[i*3]=Math.cos(t)*radius;pos[i*3+1]=Math.sin(t*2)*60;pos[i*3+2]=Math.sin(t)*radius;
      col[i*3]=.78;col[i*3+1]=.95;col[i*3+2]=.24;
    }
    geo.setAttribute('position',new THREE.BufferAttribute(pos,3));
    geo.setAttribute('color',new THREE.BufferAttribute(col,3));
    orbitRing=new THREE.Points(geo,new THREE.PointsMaterial({size:4,map:createParticleSprite(),vertexColors:true,transparent:true,opacity:.7,blending:THREE.AdditiveBlending,depthWrite:false,sizeAttenuation:true}));
    scene.add(orbitRing);

    addEventListener('resize',()=>{camera.aspect=innerWidth/innerHeight;camera.updateProjectionMatrix();renderer.setSize(innerWidth,innerHeight);});

    if(!isMobile){
      // Mouse parallax — desktop only
      addEventListener('mousemove',(e)=>{targetMouseX=(e.clientX/innerWidth-.5)*200;targetMouseY=(e.clientY/innerHeight-.5)*200;});
    }
    animate();
  }

  const clock=new THREE.Clock();
  function animate(){
    requestAnimationFrame(animate);const t=clock.getElapsedTime();
    if(!isMobile){
      mouseX+=(targetMouseX-mouseX)*.04;mouseY+=(targetMouseY-mouseY)*.04;
      camera.position.x+=(mouseX-camera.position.x)*.03;camera.position.y+=(-mouseY-camera.position.y)*.03;
      camera.lookAt(scene.position);
    }
    if(particles){particles.rotation.y=t*.04;particles.rotation.x=Math.sin(t*.05)*.1;}
    if(orbitRing){orbitRing.rotation.y=t*.15;orbitRing.rotation.x=Math.sin(t*.1)*.2;}
    bgColors.current.r+=(bgColors.target.r-bgColors.current.r)*.03;
    bgColors.current.g+=(bgColors.target.g-bgColors.current.g)*.03;
    bgColors.current.b+=(bgColors.target.b-bgColors.current.b)*.03;
    scene.background.setRGB(bgColors.current.r,bgColors.current.g,bgColors.current.b);
    scene.fog.color.setRGB(bgColors.current.r,bgColors.current.g,bgColors.current.b);
    renderer.render(scene,camera);
  }

  function setParticlePalette(mode){
    if(particleColorMode===mode||!particlesGeo)return;
    particleColorMode=mode;
    const pal=palette[mode]||palette.default;
    const colors=particlesGeo.attributes.color.array;const count=colors.length/3;
    for(let i=0;i<count;i++){const c=pal[i%pal.length];colors[i*3]=c.r;colors[i*3+1]=c.g;colors[i*3+2]=c.b;}
    particlesGeo.attributes.color.needsUpdate=true;
    if(mode==='spirulina')bgColors.target={r:.06,g:.10,b:.08};
    else if(mode==='restopil')bgColors.target={r:.08,g:.07,b:.13};
    else if(mode==='gutflo')bgColors.target={r:.12,g:.07,b:.04};
    else if(mode==='trio')bgColors.target={r:.07,g:.07,b:.10};
    else bgColors.target={r:.04,g:.06,b:.07};
  }

  /* QUIZ LOGIC */
  const TOTAL=6;
  let currentStep=0;
  let scores={spirulina:0,restopil:0,gutflo:0,trio:0};

  function getProducts(){
    const root=document.querySelector('.smr-quiz-root');
    return {
      spirulina:{tag:'RISE · ENERGY & IMMUNITY',name:'Spirulina',tagline:'Your daily nutrition in one tablet.',
        img:root.dataset.spirulinaImg||'https://cdn.shopify.com/s/files/1/0702/3132/6894/files/spirulina-bottle_430x.png',
        price:root.dataset.spirulinaPrice||'₹699',strike:root.dataset.spirulinaStrike||'₹999',
        link:root.dataset.spirulinaUrl||'/products/spirulina',
        why:'Your answers show <b>low daytime energy and a nutrition gap</b>. Spirulina (98% pure organic) delivers complete plant protein, iron and B-vitamins — naturally fueling sustained energy without the caffeine crash.',
        stats:[{num:'98%',lab:'Pure Spirulina'},{num:'120',lab:'Tablets'},{num:'0',lab:'Fillers'}]},
      restopil:{tag:'REST · SLEEP & MENTAL CALM',name:'Restopil',tagline:'Nine Ayurvedic herbs. One restful night.',
        img:root.dataset.restopilImg||'https://cdn.shopify.com/s/files/1/0702/3132/6894/files/restopil-bottle_430x.png',
        price:root.dataset.restopilPrice||'₹899',strike:root.dataset.restopilStrike||'₹1,199',
        link:root.dataset.restopilUrl||'/products/restopil',
        why:'Your answers show <b>restless sleep and a busy mind</b>. Restopil\'s 9-herb Ayurvedic blend (Brahmi, Jatamansi, Tagar) calms the nervous system — so you fall asleep faster and wake refreshed, without melatonin or sedatives.',
        stats:[{num:'9',lab:'Herbs'},{num:'60',lab:'Tablets'},{num:'0',lab:'Habit-Forming'}]},
      gutflo:{tag:'RESTORE · DAILY FIBER',name:'Gutflo',tagline:'Two ingredients. One happy gut.',
        img:root.dataset.gutfloImg||'https://cdn.shopify.com/s/files/1/0702/3132/6894/files/gutflo_430x.png',
        price:root.dataset.gutfloPrice||'₹699',strike:root.dataset.gutfloStrike||'₹999',
        link:root.dataset.gutfloUrl||'/products/gutflo',
        why:'Your answers show <b>digestive imbalance and a low-fiber routine</b>. Gutflo\'s two-ingredient blend (Lactitol + Psyllium Husk) gently eases bloating and restores regularity — no harsh laxatives, plant-based, daily-safe.',
        stats:[{num:'2',lab:'Ingredients'},{num:'227g',lab:'30 Day'},{num:'0',lab:'Stimulants'}]},
      trio:{tag:'BESTSELLER · COMPLETE RITUAL',name:'The Daily Trio',tagline:'Energy, sleep, and gut — together, daily.',
        img:root.dataset.trioImg||'https://cdn.shopify.com/s/files/1/0702/3132/6894/files/spirulina-bottle_430x.png',
        price:root.dataset.trioPrice||'₹1,897',strike:root.dataset.trioStrike||'₹2,297',
        link:root.dataset.trioUrl||'/products/the-daily-trio',
        why:'Your answers point to <b>multiple areas wanting attention</b>. The Daily Trio combines Spirulina (energy), Restopil (sleep), and Gutflo (gut) for whole-body balance — at our best bundle price.',
        stats:[{num:'3',lab:'Products'},{num:'30',lab:'Day Supply'},{num:'₹400',lab:'You Save'}]}
    };
  }

  function buildProgressDots(){
    const dotsEl=document.getElementById('smr-progress-dots');
    if(!dotsEl)return;
    dotsEl.innerHTML='';
    for(let i=1;i<=TOTAL;i++){
      const d=document.createElement('div');d.className='smr-q-progress-dot';d.dataset.step=i;dotsEl.appendChild(d);
    }
  }
  function updateDots(stepNum){
    document.querySelectorAll('.smr-q-progress-dot').forEach(d=>{
      const s=parseInt(d.dataset.step);d.classList.remove('active','done');
      if(typeof stepNum==='number'){if(s<stepNum)d.classList.add('done');else if(s===stepNum)d.classList.add('active');}
      else if(stepNum==='result'||stepNum==='loading')d.classList.add('done');
    });
  }

  function showStep(stepNum){
    document.querySelectorAll('.smr-q-step').forEach(el=>el.classList.remove('active'));
    const target=document.querySelector('.smr-q-step[data-step="'+stepNum+'"]');
    if(target)target.classList.add('active');
    updateProgress(stepNum);
    const stage=document.querySelector('.smr-q-stage');
    if(stage){
      stage.scrollTop=0;
      // Smooth scroll to top on mobile
      stage.scrollTo({top:0,behavior:'smooth'});
    }
  }

  function updateProgress(stepNum){
    const fill=document.getElementById('smr-progress-fill');
    const count=document.getElementById('smr-progress-count');
    const time=document.getElementById('smr-progress-time');
    if(!fill)return;
    if(stepNum===0){fill.style.width='0%';count.textContent="Let's begin";time.textContent='≈ 60 seconds';updateDots(0);}
    else if(stepNum==='loading'){fill.style.width='100%';count.textContent='Calculating';time.textContent='Almost there';updateDots('loading');}
    else if(stepNum==='result'){fill.style.width='100%';count.textContent='Complete';time.textContent='✓ Ready';updateDots('result');}
    else{const pct=(stepNum/TOTAL)*100;fill.style.width=pct+'%';count.textContent='Question '+stepNum+' of '+TOTAL;time.textContent=(TOTAL-stepNum)+' left';updateDots(stepNum);}
  }

  window.startQuiz=function(){currentStep=1;showStep(1);};
  window.restartQuiz=function(){
    scores={spirulina:0,restopil:0,gutflo:0,trio:0};currentStep=0;
    document.querySelectorAll('.selected').forEach(o=>o.classList.remove('selected'));
    document.querySelectorAll('.smr-q-next').forEach(b=>{b.disabled=true;b.style.opacity='.5';b.style.pointerEvents='none';});
    setParticlePalette('default');showStep(0);
  };

  function parseScore(scoreStr){
    if(!scoreStr)return null;
    const parts=scoreStr.split(',').map(s=>{const[k,v]=s.split(':');return{key:k.trim(),val:parseInt(v)};});
    parts.sort((a,b)=>b.val-a.val);return parts;
  }
  function enableNext(step){
    const next=step.querySelector('.smr-q-next');
    if(next){next.disabled=false;next.style.opacity='1';next.style.pointerEvents='auto';}
  }

  function attachListeners(){
    document.querySelectorAll('.smr-q-emoji-grid').forEach(grid=>{
      if(grid.dataset.multi==='true')return;
      grid.querySelectorAll('.smr-q-ecard').forEach(card=>{
        card.addEventListener('click',()=>{
          grid.querySelectorAll('.smr-q-ecard').forEach(o=>o.classList.remove('selected'));
          card.classList.add('selected');enableNext(card.closest('.smr-q-step'));
          const parts=parseScore(card.dataset.score);if(parts&&parts[0])setParticlePalette(parts[0].key);
        });
      });
    });
    document.querySelectorAll('.smr-q-mood').forEach(mood=>{
      mood.querySelectorAll('.smr-q-mood-btn').forEach(btn=>{
        btn.addEventListener('click',()=>{
          mood.querySelectorAll('.smr-q-mood-btn').forEach(o=>o.classList.remove('selected'));
          btn.classList.add('selected');enableNext(btn.closest('.smr-q-step'));
          const parts=parseScore(btn.dataset.score);if(parts&&parts[0])setParticlePalette(parts[0].key);
        });
      });
    });
    document.querySelectorAll('.smr-q-chips').forEach(chipset=>{
      chipset.querySelectorAll('.smr-q-chip').forEach(chip=>{
        chip.addEventListener('click',()=>{
          chip.classList.toggle('selected');
          const step=chip.closest('.smr-q-step');
          const anySelected=chipset.querySelectorAll('.smr-q-chip.selected').length>0;
          const next=step.querySelector('.smr-q-next');
          if(next){if(anySelected){next.disabled=false;next.style.opacity='1';next.style.pointerEvents='auto';}
          else{next.disabled=true;next.style.opacity='.5';next.style.pointerEvents='none';}}
        });
      });
    });
    document.querySelectorAll('.smr-q-next').forEach(btn=>{
      btn.addEventListener('click',()=>{
        const step=btn.closest('.smr-q-step');const stepNum=parseInt(step.dataset.step);
        if(step.querySelector('.smr-q-chips')){
          step.querySelectorAll('.smr-q-chip.selected').forEach(c=>{
            const parts=parseScore(c.dataset.score);
            if(parts)parts.forEach(p=>{scores[p.key]=(scores[p.key]||0)+p.val;});
          });
        } else {
          const sel=step.querySelector('.selected');
          if(sel){const parts=parseScore(sel.dataset.score);
            if(parts)parts.forEach(p=>{scores[p.key]=(scores[p.key]||0)+p.val;});}
        }
        if(stepNum<TOTAL){currentStep=stepNum+1;showStep(currentStep);}else{showLoading();}
      });
    });
    document.querySelectorAll('.smr-q-nav-prev').forEach(btn=>{
      btn.addEventListener('click',()=>{if(currentStep>1){currentStep-=1;showStep(currentStep);}});
    });
  }

  function showLoading(){
    showStep('loading');
    const phrases=['Reading your responses','Decoding sleep patterns','Mapping your nutrition gaps','Curating your ritual','Almost ready'];
    let idx=0;const el=document.getElementById('smr-loading-text');
    const interval=setInterval(()=>{idx=(idx+1)%phrases.length;if(el)el.textContent=phrases[idx];},600);
    setTimeout(()=>{clearInterval(interval);showResult();},2800);
  }

  function showResult(){
    let winner='spirulina',max=-Infinity;
    for(const k of['spirulina','restopil','gutflo','trio']){if(scores[k]>max){max=scores[k];winner=k;}}
    const sorted=Object.entries(scores).sort((a,b)=>b[1]-a[1]);
    if(sorted[0][0]!=='trio'&&sorted[1]&&(sorted[0][1]-sorted[1][1]<=1)&&(sorted[0][1]+sorted[1][1]>=8))winner='trio';
    const products=getProducts();const p=products[winner];
    document.getElementById('smr-result-img').src=p.img;
    document.getElementById('smr-result-img').alt=p.name;
    document.getElementById('smr-result-tag').textContent=p.tag;
    document.getElementById('smr-result-name').textContent=p.name;
    document.getElementById('smr-result-tagline').textContent=p.tagline;
    document.getElementById('smr-result-price').textContent=p.price;
    document.getElementById('smr-result-strike').textContent=p.strike;
    document.getElementById('smr-result-link').href=p.link+'?ref=quiz';
    document.getElementById('smr-result-why').innerHTML='<b>Why this is right for you:</b> '+p.why;
    const statsEl=document.getElementById('smr-result-stats');statsEl.innerHTML='';
    p.stats.forEach(s=>{const div=document.createElement('div');div.innerHTML='<div class="smr-q-result-stat-num">'+s.num+'</div><div class="smr-q-result-stat-lab">'+s.lab+'</div>';statsEl.appendChild(div);});
    setParticlePalette(winner);showStep('result');
  }

  function init(){
    buildProgressDots();
    attachListeners();
    initThree();
    console.log('🌿 Seamor Wellness Quiz — Mobile-Optimized Ready');
  }

  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init);}
  else{init();}
})();
